export default {
  "content": "<path d=\"M9.895 3.95a6.413 6.413 0 019.21 0c2.527 2.585 2.527 6.77 0 9.356l-7.13 7.295a4.61 4.61 0 01-6.617 0c-1.811-1.854-1.811-4.851 0-6.705l7.13-7.295a2.805 2.805 0 014.023 0 2.907 2.907 0 010 4.051l-7.13 7.295-.714-.7-.716-.697 7.13-7.295a.907.907 0 000-1.255.804.804 0 00-1.162 0l-7.13 7.295a2.814 2.814 0 000 3.907 2.608 2.608 0 003.755 0l7.13-7.295c1.768-1.809 1.768-4.751 0-6.56a4.413 4.413 0 00-6.348 0l-.973.995-1.43-1.398.972-.995z\" fill=\"#7B61FF\"/>",
  "attrs": {
    "width": "24",
    "height": "24",
    "viewBox": "0 0 24 24",
    "fill": "none",
    "xmlns": "http://www.w3.org/2000/svg"
  }
};